import styled from "styled-components";

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;

  overflow: hidden; 
  border-radius: 4px;
  border: 1px solid #D8DCDE;
  background-color: white;
`;


export const ContainerTitle = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #D8DCDE;
`;

export const ContainerType = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;

  p {
    color: #373A3E;
    font-size: 14px;
  }
  span {
    background-color: #2F5BFF;
    color: white;
    padding: 2px 8px;
    border-radius: 2px;
    font-size: 12px;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  flex: 1;
  min-height: 0;
`;


export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  gap: 24px;

  flex: 1;
  min-height: 0;
  overflow-y: auto; 
`;


export const Filters = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;

    .clear{
      display: flex;
      align-self: end;
      justify-content: end;
      padding: 10px 16px;
      color: #4256C8;
      font-size: 14px;
      cursor: pointer;
    }
`

export const State = styled.div`
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    color: #9A9FA2;
    font-size: 14px;
    text-align: center;
  }
`;

export const TableWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
`;


export const TableStyles = styled.div`
  table {
    width: 100%;
    border-spacing: 0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: white;
    border-bottom: 1px solid #D8DCDE;
  }

  th,
  td {
    white-space: nowrap;
  }
`;
